export const destinations = [
    {
      id: 0,
      code: 'PAY_DEBTS',
      title: 'Pagar deudas',
      subtitle: '',
      icon: 'AttachMoney',
      selected: false,
    },
    {
      id: 1,
      code: 'EXPAND_YOUR_HOME',
      title: 'Ampliar tu hogar',
      subtitle: '',
      icon: 'HomeWork',
      selected: false,
    },
    {
      id: 2,
      code: 'REPAIR_YOUR_CAR',
      title: 'Reparar tu auto',
      subtitle: '',
      icon: 'DirectionsCar',
      selected: false,
    },
    {
      id: 3,
      code: 'CAPITAL_YOUR_BUSINESS',
      title: 'Capital para tu negocio',
      subtitle: '',
      icon: 'BusinessCenterIcon',
      selected: false,
    },
    {
      id: 4,
      code: 'TRAVELS_AND_TOURISM',
      title: 'Viajes y turismo',
      subtitle: '',
      icon: 'Airplanemode',
      selected: false,
    },
    {
      id: 5,
      code: 'OTHER_PURPOSES',
      title: 'Otros fines',
      subtitle: '',
      icon: 'Beenhere',
      selected: false,
    }
  ]